import { render } from "./DeliverOperDetailsModal.vue?vue&type=template&id=a58121c8&ts=true"
import script from "./DeliverOperDetailsModal.vue?vue&type=script&lang=ts"
export * from "./DeliverOperDetailsModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__